/**
 * TermsCheckbox Component
 * Matching the legacy SignUpPage prototype pattern exactly.
 * Used by InviteSignupForm and ReferralSignupForm.
 */

import { useId } from 'react';
import { Link } from 'react-router-dom';

type TermsCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const TermsCheckbox = ({ checked, onChange }: TermsCheckboxProps) => {
  const checkboxId = useId();

  return (
    <div className="flex flex-col items-start">
      <div className="flex items-start">
        <input
          id={checkboxId}
          type="checkbox"
          className="mr-2 mt-2"
          style={{ transform: 'scale(1.5)' }}
          onChange={(e) => onChange(e.target.checked)}
          checked={checked}
          required
        />
        <label htmlFor={checkboxId} className="text-white font-termina ml-2">
          By signing up I acknowledge that I agree to and have read the terms of
          use and privacy policy:
        </label>
      </div>
      <div className="ml-6">
        <span className="underline text-white font-termina font-bold ml-1">
          <Link to="/terms-of-use" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </Link>
          <Link
            className="ml-3"
            to="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Link>
        </span>
      </div>
    </div>
  );
};
